/**
 * @generated SignedSource<<2187c9a1b89cc8021a741d7b095143fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteGoogleDriveFileLinkInput = {
  id?: string | null;
  taskId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteGoogleDriveFileLinkMutation$variables = {
  input: DeleteGoogleDriveFileLinkInput;
};
export type deleteGoogleDriveFileLinkMutation$data = {
  readonly deleteGoogleDriveFileLink: {
    readonly deletedGoogleDriveFileId: string | null;
  } | null;
};
export type deleteGoogleDriveFileLinkMutation = {
  variables: deleteGoogleDriveFileLinkMutation$variables;
  response: deleteGoogleDriveFileLinkMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteGoogleDriveFileLinkPayload",
    "kind": "LinkedField",
    "name": "deleteGoogleDriveFileLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedGoogleDriveFileId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteGoogleDriveFileLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteGoogleDriveFileLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d3c1274ba58121bf7b708ca078b2172f",
    "id": null,
    "metadata": {},
    "name": "deleteGoogleDriveFileLinkMutation",
    "operationKind": "mutation",
    "text": "mutation deleteGoogleDriveFileLinkMutation(\n  $input: DeleteGoogleDriveFileLinkInput!\n) {\n  deleteGoogleDriveFileLink(input: $input) {\n    deletedGoogleDriveFileId\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d63f3d26699b2be553ce3ff1b502746";

export default node;
